
<div class="multi-step-form-container" *transloco="let t; prefix: 'registration.completed'">
  <!-- Stepper Component with available templates -->
  <div class="modern-stepper">

    <h1 [innerHTML]="t('title')"></h1>

    <img
      src="assets/images/htx-registration-success.png"
      alt=""
      routerLink="/"/>

    <p>{{ t('text') }}</p>

  </div>
</div>
